import Cookies from 'universal-cookie';

export default new Cookies();
